import { render, staticRenderFns } from "./collectionOrderList.vue?vue&type=template&id=00ecfc26&scoped=true"
import script from "./collectionOrderList.vue?vue&type=script&lang=js"
export * from "./collectionOrderList.vue?vue&type=script&lang=js"
import style0 from "./collectionOrderList.vue?vue&type=style&index=0&id=00ecfc26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ecfc26",
  null
  
)

export default component.exports